export default "__VITE_ASSET__CJrv_G58__"